<template>

<div class="group" :class="{'is-row': row, 'is-slim': slim, 'is-center': center, 'is-end': end, 'is-bordered': collapsed || bordered, 'is-collapsed': collapsed, 'is-nopadding': nopadding}">

    <div class="group-title" v-if="collapsed" v-on:click="onTitleClick">

        {{ title }}

        <app-icon :name="(is.collapsed) ? 'caret-right' : 'caret-down'" />

    </div>

    <div class="group-content" v-if="!is.collapsed">

        <slot></slot>

    </div>

</div>

</template>

<script>

export default {

    props: ['row', 'slim', 'center', 'end', 'collapsed', 'bordered', 'nopadding', 'title', 'expanded'],
    
    data: function() {

        return {
            is: {
                collapsed: false
            }
        }

    },

    created: function() {

        if (this.collapsed && !this.expanded) this.is.collapsed = true

    },

    methods: {

        onTitleClick: function() {

            this.is.collapsed = !this.is.collapsed

        }

    }

}

</script>

<style scoped>

.group {
	display: flex;
	flex-direction: column;
}

.group.is-bordered {
    border: 1px solid var(--color-grey-light);
    border-radius: 4px;
    transition: all 100ms linear;
}

.is-desktop .group.is-collapsed:hover {
    border-color: var(--color-grey-highlight);
}

.group >>> .input,
.group >>> .button {
	margin-bottom: 4px;
}

.group.is-slim >>> .input,
.group.is-slim >>> .button {
	margin-bottom: 12px;
}

.group >>> .input:last-child,
.group >>> .button:last-child {
	margin-bottom: 0px;
}

.group-title {
    height: 38px;
    line-height: 40px;
    padding-left: 15px;
    cursor: pointer;
    color: var(--color-grey-dark);
    font-size: 14px;
    font-weight: 700;
}

.group-title .icon {
    position: absolute;
    right: 15px;
    top: 0px;
    line-height: 38px;
    font-size: 24px;
    color: var(--color-grey);
}

.group-content {
	display: flex;
	flex-direction: column;
    width: 100%;
}

.group.is-bordered > .group-content {
    padding: 15px;
}

.is-mobile .group.is-bordered > .group-content {
    padding: 10px;
}

.group.is-collapsed > .group-content {
    padding: 5px 15px 15px 15px;
}

.is-mobile .group.is-collapsed > .group-content {
    padding: 5px 10px 10px 10px;
}

.group.is-nopadding > .group-content {
    padding: 0px;
}

.group.is-row .group-content {
	flex-direction: row;
}

.group.is-row.is-center .group-content {
	justify-content: center;
}

.group.is-row.is-end .group-content {
	justify-content: flex-end;
}

.group.is-row >>> .input,
.group.is-row >>> .button {
	margin-bottom: 0px;
	margin: 0px 2px;
}

</style>